<div class="form-group mb-7">
    <div class="input-container">
        <input
            type="{{ type }}"
            class="form-control no-outline input-height w-100"
            [required]="control.getError('required')"
            [formControl]="control"
            placeholder="{{ control.getError('required') ? '' : label }}"
            id="{{ label }}"
        />
        @if (control.getError('required')) {
            <label for="{{ label }}">{{ label }}</label>
        }
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
        <div class="warning-alert">
            @if (control.errors?.['required']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.required' | translate }}
                </div>
            }
            @if (control.errors?.['minlength']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.minLength' | translate: { length: control.errors?.['minlength']['requiredLength'] } }}
                </div>
            }
            @if (control.errors?.['maxlength']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.maxLength' | translate: { length: control.errors?.['maxlength']['requiredLength'] } }}
                </div>
            }
            @if (!control.errors?.['minlength'] && !control.errors?.['maxLength'] && control.errors?.['trimError']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.emptySpaces' | translate }}
                </div>
            }
            @if (!control.errors?.['minlength'] && !control.errors?.['maxLength'] && control.errors?.['email']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.email' | translate }}
                </div>
            }
        </div>
    }

    @if (control.invalid && control.dirty && control.touched) {
        <div>
            @if (!control.errors?.['minlength'] && !control.errors?.['minlength'] && control.errors?.['phoneNumberError']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.phoneNumber' | translate }}
                </div>
            }
            @if (!control.errors?.['minlength'] && !control.errors?.['maxlength'] && control.errors?.['numberError']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.nip' | translate }}
                </div>
            }
        </div>
    }
    @if (control.errors?.['custom']) {
        <div class="mt-2 warning-message">
            {{ control.getError('custom') }}
        </div>
    }
</div>
